import { hardwareTestApi } from "../../api";

const HardwareTestService = {
  /**
   * Envía una solicitud para imprimir una hoja de prueba.
   * POST /api/hardware/test/printer
   */
  testPrinter: async (data: { branchId: number }) => {
    const response = await hardwareTestApi.addCustom('/printer', data);
    return response.data;
  },

  /**
   * Envía una solicitud para abrir el cajón de dinero.
   * POST /api/hardware/test/cashdrawer
   */
  testCashDrawer: async (data: { branchId: number }) => {
    const response = await hardwareTestApi.addCustom('/cashdrawer', data);
    return response.data;
  },
};

export default HardwareTestService;
